import React from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="bg-white rounded-lg p-6 max-w-md mx-auto">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {title || 'Подтверждение удаления'}
          </h3>
          <p className="text-gray-600">
            {message || 'Вы уверены, что хотите удалить этот элемент? Это действие нельзя отменить.'}
          </p>
        </div>
        
        <div className="flex justify-end space-x-3">
          <Button
            variant="secondary"
            onClick={onClose}
          >
            Отмена
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Удалить
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal; 